export default __webpack_public_path__ + "static/media/S2.f1a82d3c.png";